import { toTitleCase } from "../../../../Utils/stringUtls";
import { deliquentPolicies } from "../../../CreditForm/ProgramFeatures/CreditLimits";
import {
  additionalPayment,
  aplicableProgramFeatures,
  cardAccountStatement,
  cardActivationChannel,
  cardOrderPlacement,
  cardholderNotification,
  channel,
  constumerPaymentOptions,
  creditBreue,
  customerSupportChannels,
  customerSupportProvider,
  distributionMinimumPay,
  lockboxServices,
  paymentDistributionOpt,
  pinManagememt,
  pinManagmentOptions,
} from "../../../CreditForm/ProgramFeatures/FieldsListingLabels";

const ProgramFeaturesCreditOverview = ({ data }) => {
  const {
    pf_applicable_pf = [],
    pf_applicable_pf_other = "",
    pf_card_be_charged = "",
    pf_type_of_credit_line = "",
    pf_type_of_credit_line_company_name = "",
    pf_type_of_credit_line_contact_name = "",
    pf_type_of_credit_line_job_title = "",
    pf_type_of_credit_line_phone_number = "",
    pf_type_of_credit_line_phone_number_code = "",
    pf_type_of_credit_line_email = "",
    pf_credit_decisioning = "",
    pf_credit_decisioning_fico_vendor = "",
    pf_credit_decisioning_fico_vendor_other = "",
    pf_credit_decisioning_chc = "",
    pf_credit_decisioning_chc_company_name = "",
    pf_credit_decisioning_chc_contact_name = "",
    pf_credit_decisioning_chc_job_title = "",
    pf_credit_decisioning_chc_phone_number = "",
    pf_credit_decisioning_chc_phone_number_code = "",
    pf_credit_decisioning_chc_email = "",
    pf_workflow_and_decision_file = "",
    pf_manual_review = "",
    pf_manual_review_company_name = "",
    pf_manual_review_contact_name = "",
    pf_manual_review_job_title = "",
    pf_manual_review_phone_number = "",
    pf_manual_review_phone_number_code = "",
    pf_manual_review_email = "",
    pf_credit_limit = [],
    pf_credit_limit_modification = "",
    pf_kyc_process = "",
    pf_kyc_conduct = "",
    pf_kyc_conduct_other_company = "",
    pf_kyc_conduct_other_contact_name = "",
    pf_kyc_conduct_other_title = "",
    pf_kyc_conduct_other_phone = "",
    pf_kyc_conduct_other_phone_country = "",
    pf_kyc_conduct_other_email = "",
    pf_kyc_conduct_other_address = "",
    pf_kyb_process = "",
    pf_kyb_responsibility = "",
    pf_kyb_responsibility_other_company = "",
    pf_kyb_responsibility_other_contact_name = "",
    pf_kyb_responsibility_other_title = "",
    pf_kyb_responsibility_other_phone = "",
    pf_kyb_responsibility_other_phone_country = "",
    pf_kyb_responsibility_other_email = "",
    pf_kyb_responsibility_other_address = "",
    pf_card_order_placement = [],
    pf_card_order_placement_channel = [],
    pf_card_order_placement_channel_other = "",
    pf_card_activation_channel = [],
    pf_card_activation_channel_other = "",
    pf_pin_management = "",
    pf_pin_manage_default_pin = "",
    pf_pin_manage_default_pin_other = "",
    pf_pin_mailer = "",
    pf_offline_pin_support = "",
    pf_consumer_payment_opt = [],
    pf_consumer_payment_opt_other = "",
    pf_lockbox_services = "",
    pf_lockbox_services_other_company = "",
    pf_lockbox_services_other_contact_name = "",
    pf_lockbox_services_other_title = "",
    pf_lockbox_services_other_phone = "",
    pf_lockbox_services_other_phone_country = "",
    pf_lockbox_services_other_email = "",
    pf_min_payment_threshold = "",
    pf_min_payment_additional_amount = "",
    pf_payment_dist_opt_greater_min = "",
    pf_payment_dist_opt_for_min = "",
    pf_min_pc_pcalc_method = "",
    pf_min_pc_pprcntg_value = "",
    pf_min_pc_scalc_method = "",
    pf_min_pc_sprcntg_value = "",
    pf_payment_due_date_policy = "",
    pf_payment_due_date_policy_no_of_days = "",
    pf_payment_due_date_policy_fixed_date = "",
    pf_late_payment_penalty = "",
    pf_late_payment_fee = "",
    pf_grace_period = "",
    pf_grace_period_days = "",
    pf_card_account_statement = [],
    pf_statement_generation = "",
    pf_statment_generation_date = "",
    pf_credit_card_collection_detail = "",
    pf_credit_card_collection_detail_provider = "",
    pf_credit_card_collection_detail_provider_other = "",
    pf_credit_bureau_report_required = "",
    pf_credit_reporting_bureaus = [],
    pf_credit_reporting_bureaus_other = "",
    pf_card_usage_restriction = "",
    pf_cash_advance_limit = "",
    pf_cardholder_notification = "",
    pf_cardholder_notification_channels = "",
    pf_customer_support_channels = "",
    pf_customer_support_who_will_provide = "",
    pf_customer_support_provider_other_company = "",
    pf_customer_support_provider_other_contact_name = "",
    pf_customer_support_provider_other_title = "",
    pf_customer_support_provider_other_phone = "",
    pf_customer_support_provider_other_phone_country = "",
    pf_customer_support_provider_other_email = "",
    pf_clm_delinquent = [],
  } = data["5_0"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm">
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">Program Features</div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {pf_applicable_pf?.length
              ? aplicableProgramFeatures.map((source, index) =>
                pf_applicable_pf?.includes(source.value) ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "var(--i2c-spacing-2)",
                    }}
                    key={index}
                  >
                    {source.value === 11 ? (
                      <span>{pf_applicable_pf_other}</span>
                    ) : (
                      <span>{source.label},</span>
                    )}
                  </span>
                ) : (
                  ""
                ),
              )
              : "-"}
          </div>
        </div>
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">Credit Type</div>
          <div className="review-summary-sub-heading">
            {pf_card_be_charged?.length
              ? pf_card_be_charged?.toUpperCase()
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Type of the credit line
          </div>
          <div className="review-summary-sub-heading">
            {pf_type_of_credit_line?.length
              ? pf_type_of_credit_line?.toUpperCase()
              : "-"}
          </div>
        </div>

        {pf_type_of_credit_line === "secure" ? (
          <div i2c-grid="grid 8@md gap-sm">
            <div
              i2c-grid="12@md"
              className="fw-700 overview-val-text font-bold"
            >
              Credit data aggregator
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Company Name</div>
              <div className="overview-val-text">
                {pf_type_of_credit_line_company_name?.length
                  ? toTitleCase(pf_type_of_credit_line_company_name)
                  : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Contact name</div>
              <div className="overview-val-text">
                {pf_type_of_credit_line_contact_name?.length
                  ? toTitleCase(pf_type_of_credit_line_contact_name)
                  : "-"}
              </div>
            </div>

            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Job Title</div>
              <div className="overview-val-text">
                {pf_type_of_credit_line_job_title?.length
                  ? pf_type_of_credit_line_job_title
                  : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Cell Number</div>
              <div className="overview-val-text">
                {pf_type_of_credit_line_phone_number?.length
                  ? pf_type_of_credit_line_phone_number
                  : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Email</div>
              <div className="overview-val-text">
                {pf_type_of_credit_line_email?.length
                  ? toTitleCase(pf_type_of_credit_line_email)
                  : "-"}
              </div>
            </div>
          </div>
        ) : null}
        <div i2c-grid="12@md">
          <div className="overview-val-text font-bold mb-0">
            Credit Decisioning
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Will i2c Inc. provide credit decisioning or adjudication services?
          </div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {pf_credit_decisioning?.length
              ? pf_credit_decisioning?.toUpperCase()
              : "-"}
          </div>
        </div>
        <div i2c-grid="12@md">
          {pf_credit_decisioning === "yes" ? (
            <div>
              <div className="overview-help-text font-bold">
                Which vendor do you work with for FICO score?
              </div>
              <div
                className="overview-val-text"
                style={{
                  display: "flex",
                  gap: "var(--i2c-spacing-3)",
                  flexWrap: "wrap",
                }}
              >
                {pf_credit_decisioning_fico_vendor === "other"
                  ? pf_credit_decisioning_fico_vendor_other
                  : pf_credit_decisioning_fico_vendor?.length
                    ? pf_credit_decisioning_fico_vendor?.toUpperCase()
                    : "-"}
              </div>
            </div>
          ) : (
            <div>
              <div i2c-grid="12@md">
                <div className="overview-help-text font-bold mb-0">
                  Credit History Check
                </div>

                <div className="overview-val-text">
                  {pf_credit_decisioning_chc === "other" ? (
                    <>
                      <div i2c-grid="grid gap-sm">
                        <div i2c-grid="6@md">
                          <div className="overview-help-text font-bold">
                            Company Name
                          </div>
                          <div className="overview-val-text">
                            {pf_credit_decisioning_chc_company_name?.length
                              ? toTitleCase(
                                pf_credit_decisioning_chc_company_name,
                              )
                              : "-"}
                          </div>
                        </div>
                        <div i2c-grid="6@md">
                          <div className="overview-help-text font-bold">
                            Contact name
                          </div>
                          <div className="overview-val-text">
                            {pf_credit_decisioning_chc_contact_name?.length
                              ? toTitleCase(
                                pf_credit_decisioning_chc_contact_name,
                              )
                              : "-"}
                          </div>
                        </div>

                        <div i2c-grid="6@md">
                          <div className="overview-help-text font-bold">
                            Job Title
                          </div>
                          <div className="overview-val-text">
                            {pf_credit_decisioning_chc_job_title?.length
                              ? pf_credit_decisioning_chc_job_title
                              : "-"}
                          </div>
                        </div>
                        <div i2c-grid="6@md">
                          <div className="overview-help-text font-bold">
                            Cell Number
                          </div>
                          <div className="overview-val-text">
                            {pf_credit_decisioning_chc_phone_number?.length
                              ? pf_credit_decisioning_chc_phone_number
                              : "-"}
                          </div>
                        </div>
                        <div i2c-grid="6@md">
                          <div className="overview-help-text font-bold">
                            Email
                          </div>
                          <div className="overview-val-text">
                            {pf_credit_decisioning_chc_email?.length
                              ? toTitleCase(pf_credit_decisioning_chc_email)
                              : "-"}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    "Managed by sponsor Bank/Issuer/ISO"
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Please confirm if you want to enable a manual review in cases where
            an application has been rejected or marked for review.
          </div>
          <div i2c-grid="12@md" className="overview-val-text">
            {pf_manual_review === "yes" ? (
              <>
                <div className="overview-val-text mb-16">YES</div>
                <div i2c-grid="grid gap-sm">
                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">
                      Company Name
                    </div>
                    <div className="overview-val-text">
                      {pf_manual_review_company_name?.length
                        ? toTitleCase(pf_manual_review_company_name)
                        : "-"}
                    </div>
                  </div>
                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">
                      Contact name
                    </div>
                    <div className="overview-val-text">
                      {pf_manual_review_contact_name?.length
                        ? toTitleCase(pf_manual_review_contact_name)
                        : "-"}
                    </div>
                  </div>

                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">
                      Job Title
                    </div>
                    <div className="overview-val-text">
                      {pf_manual_review_job_title?.length
                        ? pf_manual_review_job_title
                        : "-"}
                    </div>
                  </div>
                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">
                      Cell Number
                    </div>
                    <div className="overview-val-text">
                      {pf_manual_review_phone_number?.length
                        ? pf_manual_review_phone_number
                        : "-"}
                    </div>
                  </div>
                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">Email</div>
                    <div className="overview-val-text">
                      {pf_manual_review_email?.length
                        ? toTitleCase(pf_manual_review_email)
                        : "-"}
                    </div>
                  </div>
                </div>
              </>
            ) : pf_manual_review?.length ? (
              pf_manual_review?.toUpperCase()
            ) : (
              "-"
            )}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="overview-val-text font-bold mb-8">Credit Limit</div>
          <div className="overview-help-text font-bold">
            Please confirm if you want the credit limits to be assigned based on
            your credit decisioning model or will these be defined manually.
          </div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {pf_credit_limit?.length
              ? [
                {
                  label: "Assign limit based on credit decisioning",
                  value: 0,
                },
                {
                  label:
                    "Assign limit manually from the administrative portal",
                  value: 1,
                },
              ].map((source, index) =>
                pf_credit_limit?.includes(source.value) ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "var(--i2c-spacing-2)",
                    }}
                    key={index}
                  >
                    <span>{source.label},</span>
                  </span>
                ) : (
                  ""
                ),
              )
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="overview-val-text font-bold mb-8">
            Credit Limit Modification
          </div>
          <div className="overview-help-text font-bold">
            Can the initially assigned credit limit be increased or decreased
            for the consumers in this card program?
          </div>
          <div className="overview-val-text mb-16">
            {pf_credit_limit_modification?.length
              ? pf_credit_limit_modification?.toUpperCase()
              : "-"}
          </div>
          {pf_credit_limit_modification === "yes" ? (
            <div i2c-grid="12@md">
              {/* pf_clm_delinquent */}
             
              <div className="overview-help-text font-bold mb-16">
                Charge-Off Process and Delinquent Accounts Policy
              </div>
              <div className="overview-val-text  ">
                <table border={1} cellSpacing={0}>
                  <thead>
                    <tr>
                      <th width="400">Delinquency Action</th>
                      <th width="300">Days Past Due (DPD)</th>
                      <th width="100">Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pf_clm_delinquent?.map((policy, index) => (
                      <tr key={index}>
                        <td width="400">
                          {deliquentPolicies.find(
                            (option) =>
                              option.value ===
                              policy?.pf_clm_deliquency_action ?? "-",
                          )?.label ?? +"-"}
                        </td>
                        <td width="300">
                          {policy?.pf_clm_days_past_dueL ?? "-"}
                        </td>
                        <td width="100">
                          {policy?.pf_clm_days_month_opt ?? "-"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : null}
        </div>


        <div i2c-grid="12@md">
          <div className="overview-val-text font-bold mb-4">KYC Process</div>
          <div className="overview-help-text font-bold">
            Will KYC procedures be conducted to retain cardholder information
            such as Address, DOB, and ID to meet the applicable legal and
            regulatory compliance requirements?
          </div>
          <div className="overview-val-text mb-16">
            {pf_kyc_process?.length ? pf_kyc_process?.toUpperCase() : "-"}
          </div>
          {pf_kyc_process === "yes" ? (
            <div>
              <div i2c-grid="12@md">
                <div className="overview-help-text font-bold mb-0">
                  Who will conduct KYC?
                </div>
              </div>
              <div i2c-grid="6@md">
                {pf_kyc_conduct !== "other" ? (
                  <div className="overview-help-text">
                    {toTitleCase(pf_kyc_conduct?.length ? pf_kyc_conduct : "-")}
                  </div>
                ) : (
                  <>
                    <div i2c-grid="grid gap-sm">
                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Company Name
                        </div>
                        <div className="overview-val-text">
                          {pf_kyc_conduct_other_company?.length
                            ? toTitleCase(pf_kyc_conduct_other_company)
                            : "-"}
                        </div>
                      </div>
                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Contact name
                        </div>
                        <div className="overview-val-text">
                          {pf_kyc_conduct_other_contact_name?.length
                            ? toTitleCase(pf_kyc_conduct_other_contact_name)
                            : "-"}
                        </div>
                      </div>

                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Job Title
                        </div>
                        <div className="overview-val-text">
                          {pf_kyc_conduct_other_title?.length
                            ? pf_kyc_conduct_other_title
                            : "-"}
                        </div>
                      </div>
                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Cell Number
                        </div>
                        <div className="overview-val-text">
                          {pf_kyc_conduct_other_phone?.length
                            ? pf_kyc_conduct_other_phone
                            : "-"}
                        </div>
                      </div>
                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Email
                        </div>
                        <div className="overview-val-text">
                          {pf_kyc_conduct_other_email?.length
                            ? toTitleCase(pf_kyc_conduct_other_email)
                            : "-"}
                        </div>
                      </div>
                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Physical Address
                        </div>
                        <div className="overview-val-text">
                          {pf_kyc_conduct_other_address?.length
                            ? toTitleCase(pf_kyc_conduct_other_address)
                            : "-"}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          ) : null}
        </div>


        <div i2c-grid="12@md">
          <div className="overview-val-text font-bold mb-4">KYB Process</div>
          <div className="overview-help-text font-bold">
            Will KYB (Know Your Business) procedures be conducted to examine entities that you wish to onboard.
          </div>
          <div className="overview-val-text mb-16">
            {pf_kyb_process?.length ? pf_kyb_process?.toUpperCase() : "-"}
          </div>
          {pf_kyb_process === "yes" ? (
            <div>
              <div i2c-grid="6@md">
                <div className="overview-help-text font-bold">
                  Who will conduct KYB Responsibilities?
                </div>

                {pf_kyb_responsibility !== "other" ? (
                  <div className="overview-help-text">
                    {toTitleCase(
                      pf_kyb_responsibility?.length
                        ? pf_kyb_responsibility
                        : "-",
                    )}
                  </div>
                ) : (
                  <>
                    <div i2c-grid="grid gap-sm">
                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Company Name
                        </div>
                        <div className="overview-val-text">
                          {pf_kyb_responsibility_other_company?.length
                            ? toTitleCase(pf_kyb_responsibility_other_company)
                            : "-"}
                        </div>
                      </div>
                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Contact name
                        </div>
                        <div className="overview-val-text">
                          {pf_kyb_responsibility_other_contact_name?.length
                            ? toTitleCase(
                              pf_kyb_responsibility_other_contact_name,
                            )
                            : "-"}
                        </div>
                      </div>

                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Job Title
                        </div>
                        <div className="overview-val-text">
                          {pf_kyb_responsibility_other_title?.length
                            ? pf_kyb_responsibility_other_title
                            : "-"}
                        </div>
                      </div>
                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Cell Number
                        </div>
                        <div className="overview-val-text">
                          {pf_kyb_responsibility_other_phone?.length
                            ? pf_kyb_responsibility_other_phone
                            : "-"}
                        </div>
                      </div>
                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Email
                        </div>
                        <div className="overview-val-text">
                          {pf_kyb_responsibility_other_email?.length
                            ? toTitleCase(pf_kyb_responsibility_other_email)
                            : "-"}
                        </div>
                      </div>
                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Physical Address
                        </div>
                        <div className="overview-val-text">
                          {pf_kyb_responsibility_other_address?.length
                            ? toTitleCase(pf_kyb_responsibility_other_address)
                            : "-"}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          ) : null}
        </div>

        <div i2c-grid="12@md">
          <div className="overview-val-text  font-bold mb-4">
            Card Order Placement
          </div>
          <div className="overview-help-text font-bold mb-8">
            How will a customer request to order a card and which channels will
            be used to send the card ordering requests?
          </div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {pf_card_order_placement?.length
              ? cardOrderPlacement?.map((source, index) =>
                pf_card_order_placement?.includes(source.value) ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "var(--i2c-spacing-2)",
                    }}
                    key={index}
                  >
                    <span>{source.label},</span>
                  </span>
                ) : (
                  ""
                ),
              )
              : "-"}
          </div>

          <div className="overview-val-text mt-16 mb-4 font-bold">
            Select the channels:
          </div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {pf_card_order_placement_channel?.length
              ? channel.map((source, index) =>
                pf_card_order_placement_channel?.includes(source.value) ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "var(--i2c-spacing-2)",
                    }}
                    key={index}
                  >
                    {source.value === 5 ? (
                      pf_card_order_placement_channel_other + ", "
                    ) : (
                      <span>{source.label},</span>
                    )}
                  </span>
                ) : (
                  ""
                ),
              )
              : "-"}
          </div>

          <div className="overview-help-text font-bold mt-16 mb-0">
            Card Activation Channels
          </div>
          <div className="overview-help-text font-bold mb-4">
            Select the i2c Inc. channels/interfaces you want the cardholders to
            use to activate card accounts.
          </div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {pf_card_activation_channel?.length
              ? cardActivationChannel.map((source, index) =>
                pf_card_activation_channel?.includes(source.value) ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "var(--i2c-spacing-2)",
                    }}
                    key={index}
                  >
                    {source.value === 5 ? (
                      pf_card_activation_channel_other + ", "
                    ) : (
                      <span>{source.label},</span>
                    )}
                  </span>
                ) : (
                  ""
                ),
              )
              : "-"}
          </div>

          <div i2c-grid="12@md">
            <div className="overview-help-text font-bold mt-16">
              PIN Management
            </div>
            <div className="overview-help-text font-bold mb-4">
              How will the first card PIN be generated for the card?
            </div>
            <div className="review-summary-sub-heading mb-8">
              {
                pinManagmentOptions.find(
                  (opt) => opt.value === pf_pin_management,
                )?.label
              }
            </div>
            {pf_pin_management === "default-pin" ? (
              <>
                <div className="overview-help-text font-bold mb-4">
                  If you select the default PIN option, please confirm the
                  default PIN value.
                </div>
                <div className="review-summary-sub-heading">
                  {pf_pin_manage_default_pin !== "other"
                    ? pinManagememt.find(
                      (opt) => opt.value === pf_pin_manage_default_pin,
                    )?.label
                    : pf_pin_manage_default_pin_other}
                </div>
              </>
            ) : null}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            If you want to send the PIN through PIN Mailer?
          </div>
          <div className="review-summary-sub-heading">
            {pf_pin_mailer?.length ? pf_pin_mailer?.toUpperCase() : "-"}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Would you like Offline PIN support enabled for your BIN (mainly
            applicable for EU and Canada)?
          </div>
          <div className="review-summary-sub-heading">
            {pf_offline_pin_support?.length
              ? pf_offline_pin_support?.toUpperCase()
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="overview-val-text font-bold mt-16 mb-8">
            Consumer Payment Options
          </div>
          <div className="overview-help-text font-bold mb-4">
            Specify the payment options that you wish to enable for your
            cardholders.
          </div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {pf_consumer_payment_opt?.length
              ? constumerPaymentOptions.map((source, index) =>
                pf_consumer_payment_opt?.includes(source.value) ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "var(--i2c-spacing-2)",
                    }}
                    key={index}
                  >
                    {source.value === 3 ? (
                      pf_consumer_payment_opt_other + ", "
                    ) : (
                      <span>{source.label},</span>
                    )}
                  </span>
                ) : (
                  ""
                ),
              )
              : "-"}
          </div>
        </div>


        <div i2c-grid="12@md">
          <div className="overview-val-text  font-bold mb-4">
            Lockbox Service{" "}
          </div>
          {pf_lockbox_services !== "other" ? (
            <div className="overview-help-text">
              {
                lockboxServices.find((opt) => opt.value === pf_lockbox_services)
                  ?.label
              }
            </div>
          ) : (
            <>
              {" "}
              <div className="overview-help-text font-bold mt-0">
                Please specify who will manage this service.
              </div>
              <div i2c-grid="grid gap-sm">
                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">
                    Company Name
                  </div>
                  <div className="overview-val-text">
                    {pf_lockbox_services_other_company?.length
                      ? toTitleCase(pf_lockbox_services_other_company)
                      : "-"}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">
                    Contact name
                  </div>
                  <div className="overview-val-text">
                    {pf_lockbox_services_other_contact_name?.length
                      ? toTitleCase(pf_lockbox_services_other_contact_name)
                      : "-"}
                  </div>
                </div>

                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">Job Title</div>
                  <div className="overview-val-text">
                    {pf_lockbox_services_other_title?.length
                      ? pf_lockbox_services_other_title
                      : "-"}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">Phone</div>
                  <div className="overview-val-text">
                    {pf_lockbox_services_other_phone?.length
                      ? pf_lockbox_services_other_phone
                      : "-"}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">Email</div>
                  <div className="overview-val-text">
                    {pf_lockbox_services_other_email?.length
                      ? toTitleCase(pf_lockbox_services_other_email)
                      : "-"}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <div i2c-grid="12@md">
          <div className="overview-val-text  font-bold mb-4">
            Minimum Payment Calculation{" "}
          </div>
          <div className="overview-help-text font-bold mb-16">
            Minimum payment will be calculated for this card program
          </div>
          <div className="overview-val-text ">
            <table border={1} cellSpacing={0}>
              <thead>
                <tr>
                  <th width="400">Select Primary Calculation Method</th>
                  <th width="300">Define Percentage Value</th>
                </tr>
              </thead>
              <tbody>
                <tr key={1}>
                  <td width="400">{pf_min_pc_pcalc_method}</td>
                  <td width="400">
                    {pf_min_pc_pprcntg_value}
                    <span className="font-bold">%</span>
                  </td>
                </tr>
                {pf_min_pc_scalc_method?.length &&
                  pf_min_pc_sprcntg_value?.length ? (
                  <tr key={2}>
                    <td width="400">{pf_min_pc_scalc_method}</td>
                    <td width="400">
                      {pf_min_pc_sprcntg_value}
                      <span className="font-bold">%</span>
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
          <div i2c-grid="6@md" className="mt-16">
            <div className="overview-help-text font-bold">
              Minimum Payment Threshold
            </div>
            <div className="overview-val-text">
              {pf_min_payment_threshold?.length
                ? toTitleCase(pf_min_payment_threshold)
                : "-"}
            </div>
          </div>
        </div>

        <div i2c-grid="12@md">
          <div
            className="overview-help-text font-bold mb-0"
            style={{ marginBottom: "0px" }}
          >
            Select additional amounts to be included in the minimum payment.
          </div>
          <div className="overview-help-text mt-8">
            {
              additionalPayment.find(
                (opt) => opt.value === pf_min_payment_additional_amount,
              )?.label
            }
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="overview-val-text font-bold mb-8">
            Payment Distribution Options
          </div>
          <div className="overview-help-text font-bold mb-0">
            Distribution options for payments greater than the minimum.
          </div>
          <div className="overview-help-text mt-8">
            {
              paymentDistributionOpt.find(
                (opt) => opt.value === pf_payment_dist_opt_greater_min,
              )?.label
            }
          </div>
        </div>
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold mb-0">
            Distribution options for the minimum payment.
          </div>
          <div className="overview-help-text mt-0">
            {
              distributionMinimumPay.find(
                (opt) => opt.value === pf_payment_dist_opt_for_min,
              )?.label
            }
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold mb-0">
            Payment Due Date
          </div>
          <div className="overview-help-text font-bold mb-0">
            Please confirm your Due Date policy.
          </div>
          <span className="overview-help-text">
            {"no-of-days" === pf_payment_due_date_policy
              ? "Number of Days."
              : "Fixed Date."}
          </span>
        </div>
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold mt-0">
            {"no-of-days" === pf_payment_due_date_policy
              ? "Specify the number of days."
              : "Specify the due date."}
          </div>
          <div className="overview-help-text  mt-0">
            {"no-of-days" === pf_payment_due_date_policy
              ? pf_payment_due_date_policy_no_of_days
              : pf_payment_due_date_policy_fixed_date}
          </div>
        </div>

        <div i2c-grid="12@md gap-sm">
          <div className="overview-val-text font-bold mb-8">
            Late Payment Penalty
          </div>
          <div className="overview-help-text font-bold mb-0">
            Do you wish to define a late payment fee?
          </div>
          <div className="overview-help-text mt-4">
            {pf_late_payment_penalty?.length
              ? pf_late_payment_penalty?.toUpperCase()
              : "-"}
          </div>
          {pf_late_payment_penalty === "yes" ? (
            <div className="overview-help-text mt-0">{pf_late_payment_fee}</div>
          ) : null}

          <div className="overview-help-text font-bold mb-0">
            Do you wish to define a grace period for late payment?
          </div>
          <div className="overview-help-text mt-4">
            {pf_grace_period?.length ? pf_grace_period?.toUpperCase() : "-"}
          </div>
          {pf_grace_period === "yes" ? (
            <div className="overview-help-text mt-0">
              {pf_grace_period_days}
            </div>
          ) : null}
        </div>

        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold mb-0">
            Card Account Statements
          </div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {pf_card_account_statement?.length
              ? cardAccountStatement.map((source, index) =>
                pf_card_account_statement?.includes(source.value) ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "var(--i2c-spacing-2)",
                    }}
                    key={index}
                  >
                    <span>{source.label},</span>
                  </span>
                ) : (
                  ""
                ),
              )
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md gap-sm">
          <div className="overview-val-text font-bold mb-8">
            Statement Generation Date
          </div>
          <div className="overview-help-text font-bold mb-0">
            Do you want to specify the statement generation day of the month?
          </div>
          <div className="overview-help-text mt-4">
            {pf_statement_generation?.length
              ? pf_statement_generation?.toUpperCase()
              : "-"}
          </div>
          <div className="overview-help-text font-bold mb-0">
            Statement will be generated on the:
          </div>
          {pf_statement_generation === "yes" ? (
            <div className="overview-help-text mt-0">
              {toTitleCase(pf_statment_generation_date?.replaceAll("-", " "))}
            </div>
          ) : null}
        </div>

        <div i2c-grid="12@md gap-sm">
          <div className="overview-val-text font-bold mb-8">
            Credit Card Collection Details{" "}
          </div>
          <div className="overview-help-text font-bold mb-0">
            Do you want i2c Inc. to provide account details for collection
            services?
          </div>
          <div className="overview-help-text mt-4">
            {pf_credit_card_collection_detail?.length
              ? pf_credit_card_collection_detail?.toUpperCase()
              : "-"}
          </div>
          {pf_credit_card_collection_detail === "yes" ? (
            <>
              <div className="overview-help-text font-bold mb-0">
                Please confirm who will i2c Inc. provide account details for
                closed accounts intended for collection services.
              </div>
              <div className="overview-help-text mt-0">
                {pf_credit_card_collection_detail_provider === "other"
                  ? toTitleCase(pf_credit_card_collection_detail_provider_other)
                  : "Program owner, specified above"}
              </div>
            </>
          ) : null}
        </div>

        <div i2c-grid="12@md gap-sm">
          <div className="overview-val-text font-bold mb-8">
            Credit Bureau Reporting
          </div>
          <div className="overview-help-text font-bold mb-0">
            Please confirm if you want to subscribe to i2c Inc. credit bureau
            reporting services.
          </div>
          <div className="overview-help-text mt-4">
            {pf_credit_bureau_report_required?.length
              ? pf_credit_bureau_report_required?.toUpperCase()
              : "-"}
          </div>
          {pf_credit_bureau_report_required === "yes" ? (
            <>
              <div className="overview-help-text font-bold mb-0">
                Please specify the credit bureaus below:
              </div>
              <div
                className="overview-val-text"
                style={{
                  display: "flex",
                  gap: "var(--i2c-spacing-3)",
                  flexWrap: "wrap",
                }}
              >
                {pf_credit_reporting_bureaus?.length
                  ? creditBreue.map((source, index) =>
                    pf_credit_reporting_bureaus?.includes(source.value) ? (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "var(--i2c-spacing-2)",
                        }}
                        key={index}
                      >
                        {source.value === 3 ? (
                          <span>{pf_credit_reporting_bureaus_other}</span>
                        ) : (
                          <span>{source.label},</span>
                        )}
                      </span>
                    ) : (
                      ""
                    ),
                  )
                  : "-"}
              </div>
            </>
          ) : null}
        </div>

        <div i2c-grid="12@md gap-sm">
          <div className="overview-val-text font-bold mb-8">
            Card Usage Restrictions
          </div>
          <div className="overview-help-text font-bold mb-0">
            Do you want to limit where a card can be used?
          </div>
          <div className="overview-help-text mt-4">
            {pf_card_usage_restriction?.length
              ? pf_card_usage_restriction?.toUpperCase()
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md gap-sm">
          <div className="overview-val-text font-bold mb-8">
            Cash Advance Limits
          </div>
          <div className="overview-help-text font-bold mb-0">
            Do you want to limit where a card can be used?
          </div>
          <div className="overview-help-text mt-4">
            {pf_cash_advance_limit?.length
              ? pf_cash_advance_limit?.toUpperCase()
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md gap-sm">
          <div className="overview-val-text font-bold mb-8">
            Cardholder Notifications
          </div>
          <div className="overview-help-text font-bold mb-0">
            Will the card account activity related notifications be sent to
            cardholders or program managers?
          </div>
          <div className="overview-help-text mt-4">
            {cardholderNotification.find(
              (opt) => pf_cardholder_notification === opt.value,
            )?.label ?? "-"}
          </div>
          <div className="overview-help-text font-bold mb-0">
            Please select the channel through which alerts will be shared:
          </div>
          <div className="overview-help-text mt-4">
            {pf_cardholder_notification_channels?.length
              ? pf_cardholder_notification_channels?.toUpperCase()
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md gap-sm">
          <div className="overview-val-text font-bold mb-8">
            Customer Support
          </div>
          <div className="overview-help-text font-bold mb-0">
            Which customer support channels will be available for cardholders:
          </div>
          <div className="overview-help-text mt-4">
            {customerSupportChannels.find(
              (opt) => opt.value === pf_customer_support_channels,
            )?.label ?? "-"}
          </div>

          <div className="overview-help-text font-bold mb-0">
            Who will provide customer support?
          </div>
          <div className="overview-help-text mt-4">
            {customerSupportProvider.find(
              (opt) => opt.value === pf_customer_support_who_will_provide,
            )?.label ?? "-"}
          </div>
          {pf_customer_support_who_will_provide !== "i2c" ? (
            <>
              <div className="overview-help-text font-bold mb-0">
                3rd Party Vendor details:
              </div>
              <div i2c-grid="grid gap-sm">
                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">
                    Company Name
                  </div>
                  <div className="overview-val-text">
                    {pf_customer_support_provider_other_company?.length
                      ? toTitleCase(pf_customer_support_provider_other_company)
                      : "-"}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">
                    Contact name
                  </div>
                  <div className="overview-val-text">
                    {pf_customer_support_provider_other_contact_name?.length
                      ? toTitleCase(
                        pf_customer_support_provider_other_contact_name,
                      )
                      : "-"}
                  </div>
                </div>

                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">Job Title</div>
                  <div className="overview-val-text">
                    {pf_customer_support_provider_other_title?.length
                      ? pf_customer_support_provider_other_title
                      : "-"}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">Phone</div>
                  <div className="overview-val-text">
                    {pf_customer_support_provider_other_phone?.length
                      ? pf_customer_support_provider_other_phone
                      : "-"}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">Email</div>
                  <div className="overview-val-text">
                    {pf_customer_support_provider_other_email?.length
                      ? toTitleCase(pf_customer_support_provider_other_email)
                      : "-"}
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};
export default ProgramFeaturesCreditOverview;
